
<div class="padding-20 ui-g" id="c3_searchCategories_Modal">


  <!-- Bottoni Annulla e Aggiungi -->

  <div class="ui-dialog-footer fixed-buttons buttonsContainer">
    <button pButton (click)="onClickCancelCategories()" type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
    <button pButton type="button" (click)="onClickAddCategories()" type="button" class="k-generic-btn footer-btn" label="{{'common.add' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>

  <br />
  <br />
  <br />

  <div class="filters"></div>
<div class="categoryLevels">
  <ng-container *ngTemplateOutlet="recursiveCategoryTree; context:{ $implicit: categoryTree, level: 0 }"></ng-container>

  <ng-template #recursiveCategoryTree data-testid="recursiveCategoryTree" let-categories let-level="level">
    <div *ngFor="let category of categories; let i=index;" class="category-item" [style.marginLeft.px]="level * 24">
      <div class="category-row">
        <span *ngIf="category.children?.length > 0"
              class="arrow"
              [class.expanded]="category.expanded"
              (click)="toggleCategory(category)">
          <i class="fa" [ngClass]="{'fa-caret-right': !category.expanded, 'fa-caret-down': category.expanded}"></i>
        </span>

        <p-checkbox
          [binary]="true"
          [(ngModel)]="category.rowSelected"
          class="checkbox"
          (onChange)="onSelectedCategory(category)">
        </p-checkbox>

        <div class="category-details">
          <div class="category-code">{{ category.code }}</div>
          <div class="category-description">{{ category.description }}</div>
        </div>
      </div>

<div *ngIf="category.expanded && category.children && category.children.length > 0" class="child-categories">
        <ng-container *ngTemplateOutlet="recursiveCategoryTree; context:{ $implicit: category.children, level: level + 1 }"></ng-container>
      </div>
    </div>
  </ng-template>
</div>




</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-categories/campaign-3-search-categories.component.html